import { IconOneTwoThird } from '@hivebrite/design-system/Icon';

const OneTwoThird = () => <div />; // never used

OneTwoThird.componentName = 'OneTwoThird';
OneTwoThird.componentType = 'section';

OneTwoThird.componentLabel = __('1/3 - 2/3');
OneTwoThird.componentCategory = 'empty-structure';
OneTwoThird.componentIcon = () => IconOneTwoThird;

OneTwoThird.canBeDragged = true;
OneTwoThird.canBeListed = true;
OneTwoThird.canBeSelected = true;

OneTwoThird.item = ({ bodyWidth, components, features }) => {
  const { Column, Section } = components;
  const nbColumns = 2;

  return Section.item({
    children: Array(nbColumns)
      .fill()
      .map((_, index) =>
        Column.item({
          width: `${((index + 1) / 3) * 100}%`,
        }),
      ),
    features: {
      ...features,
      section: {
        ...features?.section,
        name: OneTwoThird.componentName,
        sectionWidth: bodyWidth,
      },
    },
  });
};

export default OneTwoThird;
